// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ZME8x";
export var container = "footer-module--container--FZPCc";
export var nav = "footer-module--nav--6PTPl";
export var sm_div = "footer-module--sm_div--6wBL6";
export var images_div = "footer-module--images_div--hlySd";